import {
  ProgressWithContentActivity,
  ProgressWithContentType,
  ProgressWithStatusType,
  TopicsListTopic
} from "../StudentBoard/StudentBoard.type";
import {ActivityContent, ActivityStatusWithContent} from "./Lesson.type";

export const mergeWithActivitiesContent = ({
  activitiesProgress,
  activitiesContent,
}: {
  activitiesProgress: ProgressWithContentActivity[],
  activitiesContent: ActivityContent[],
}): ActivityStatusWithContent[] => {
  // @ts-ignore
  return activitiesProgress.map(activityProgress => {
    const activityContent = activitiesContent?.find(contentItem => contentItem._id.toString() === activityProgress.id.toString());

    return {
      ...activityContent,
      ...activityProgress,
    }
  })
}
